package com.karawek.core.auth.usecase

import com.karawek.core.auth.api.Authenticator
import com.karawek.core.auth.model.AuthenticationInfo
import com.karawek.core.auth.model.EmptyOtpHandle
import com.karawek.core.auth.model.OtpHandle
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Inject
@SingleIn(AppScope::class)
class VerifyOtpUseCase(
    private val authenticator: Authenticator,
) {
    suspend operator fun invoke(
        handle: OtpHandle,
        otpCode: String,
    ): Result<AuthenticationInfo> {
        if (handle is EmptyOtpHandle) {
            return Result.failure(IllegalStateException("No OTP session active. Request a new code to continue."))
        }
        return authenticator.verifyOtp(
            handle = handle,
            otpCode = otpCode,
        )
    }
}
